import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';

// Layout for auth pages
const AuthLayout = ({ pageTitle, children }) => {
  const appName = process.env.REACT_APP_NAME;

  return (
    <>
      <Helmet>
        <title>
          {appName} - {pageTitle}
        </title>
      </Helmet>

      {children}
    </>
  );
};

AuthLayout.propTypes = {
  pageTitle: PropTypes.string.isRequired,
  children: PropTypes.any.isRequired,
};

export default AuthLayout;
